import SampleReport from "./SampleReport.jsx";

export default SampleReport;
